import React from 'react'

const PrivacyPolicy = () => {
  return (
    <div className="min-h-screen bg-background py-20">
      <div className="max-w-4xl mx-auto px-4">
        <div className="bg-white rounded-2xl shadow-sm border border-gray-100 p-10">
          <h1 className="text-3xl font-bold text-primary mb-8 border-b pb-4">Privacy & Policy</h1>
          
          <div className="space-y-8">
            <section>
              <h2 className="text-xl font-bold text-gray-900 mb-4">Data Handling</h2>
              <p className="text-gray-600 mb-4">
                Maldroid is designed with user privacy as a priority. The application includes specific settings to manage your data:
              </p>
              <ul className="list-disc pl-6 space-y-2 text-gray-600">
                {/* <li><strong>Auto-delete scan logs:</strong> The app supports auto-deletion of scan logs after 30 days.</li> */}
                <li><strong>Cache Control:</strong> Users can "Clear cached APK analysis" to remove temporary files used during scans.</li>
                <li><strong>Local Processing:</strong> The ML model processes features locally to minimize data exposure.</li>
              </ul>
            </section>

            <section>
              <h2 className="text-xl font-bold text-gray-900 mb-4">Permissions Required</h2>
              <p className="text-gray-600 mb-4">
                Maldroid adheres to the principle of least privilege. We only request permissions necessary for malware detection.
              </p>
              
              <div className="overflow-x-auto">
                <table className="w-full text-left border-collapse">
                  <thead>
                    <tr className="bg-gray-50 text-sm text-gray-700">
                      <th className="p-4 border-b">Permission</th>
                      <th className="p-4 border-b">Purpose</th>
                    </tr>
                  </thead>
                  <tbody className="text-sm text-gray-600">
                    <tr>
                      <td className="p-4 border-b font-mono text-xs">READ_EXTERNAL_STORAGE</td>
                      <td className="p-4 border-b">Access APK files from device storage for scanning.</td>
                    </tr>
                    <tr>
                      <td className="p-4 border-b font-mono text-xs">QUERY_ALL_PACKAGES</td>
                      <td className="p-4 border-b">List all installed apps for scanning (Android 11+).</td>
                    </tr>
                    <tr>
                      <td className="p-4 border-b font-mono text-xs">INTERNET</td>
                      <td className="p-4 border-b">Enable cloud verification, updates, and reporting.</td>
                    </tr>
                    <tr>
                      <td className="p-4 border-b font-mono text-xs">FOREGROUND_SERVICE</td>
                      <td className="p-4 border-b">Run scans continuously while the app is active.</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </section>
          </div>
        </div>
      </div>
    </div>
  )
}

export default PrivacyPolicy